/**
 * 购买free follow
 */
import {
  checkFreeFollowers,
  deliverFreeFollowers
} from "@/api/cg/service/user_service";
import Event_bus from "@/utils/event_bus";
import nativeStorage from "@/utils/nativeStorage/local_storage";
import { Vue } from "@/main";
import IntervalTimer from "@/components/DlalogTsx/interval_timer";
import DialogLoginBtn from "@/components/DlalogTsx/FreeFollow/DialogLoginBtn";
import { store } from "@/main";
import * as types from "@/store/constants/index_types";
import * as ins_user_info_types from "@/store/constants/ins_user_info_types";
import generator from "@/services/open_pop_up/open_generator";
import { HAS_SHOW_FREE_FOLLOW } from "@/utils/nativeStorage/local_keys";
class FreeFollowUtil {
  get masterId() {
    return store.getters[types.GETTER_MASTER_USER_ID];
  }
  get currentInsUserId() {
    return store.getters[types.GETTER_CURRENT_USER_ID];
  }

  get currentInsUserInfo() {
    return store.getters[ins_user_info_types.GETTER_CURRENT_INS_USER_INFO];
  }

  public showLoginDialog() {
    try {
      Vue.prototype.$_Dialog.show({
        avatar: require("@/assets/icons-file/followers/pic_pop_loginrequired@3x.png"),
        title: "Login Required",
        content: {
          text: `To get this <%FREE followers reward, log in/%> to your Instagram account first.`,
          highlightColor: "rgb(79,121,255)"
        },
        closable: false,
        cancelBtn: {
          text: "Not Now"
        },
        confirmBtnCustom(ctx: any, r: any) {
          return r(DialogLoginBtn, { props: { ctx } });
        },
        onCancel(done: any) {
          done();
          clearInterval(IntervalTimer.getTimer());
        }
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public showGetFailedDialog() {
    Vue.prototype.$_Dialog.show({
      title: "Sorry!",
      content: {
        text: `FREE followers are exclusive for newbies, please enjoy our other benefits. More bonus are waiting for you!`
      },
      closable: false,
      closeOnClickModal: true,
      avatar: require("@/assets/icons-file/followers/pic_pop_sorry@3x.png"),
      onConfirm(done: any) {
        done();
        generator.next();
      }
    });
  }
  public getFreeFollow() {
    if (
      !this.currentInsUserId ||
      this.currentInsUserInfo.user_type === "search"
    ) {
      // 没登陆，提示登陆
      this.showLoginDialog();
    } else {
      this.getFollower();
    }
  }
  public closeFreeFollowDialog() {
    nativeStorage.set(HAS_SHOW_FREE_FOLLOW, true);
    Event_bus.$emit("is_show_free_follow", false);
  }
  public async getFollower() {
    try {
      this.closeFreeFollowDialog();
      Vue.prototype.$_Toast.show({
        type: "loading",
        text: "Processing"
      });
      // 检测是否可以领取
      const checkResult: any = await checkFreeFollowers(
        this.masterId,
        this.currentInsUserId
      );
      if (checkResult && checkResult.free_status === 1) {
        // 直接领取
        const deliverResult: any = await deliverFreeFollowers(
          this.masterId,
          this.currentInsUserId,
          {
            ...this.currentInsUserInfo.ins_user_info,
            initial_count: this.currentInsUserInfo.ins_user_info.follower_count,
            username: this.currentInsUserInfo.ins_user_info.user_name,
            user_id: this.currentInsUserId
          }
        );
        if (deliverResult) {
          // 发toast 提示成功。
          Vue.prototype.$_Toast.show({
            duration: 3000,
            text: `Congrats @${this.currentInsUserInfo.ins_user_info.user_name}, 5 followers will arrive soon.`
          });
        }
        setTimeout(() => {
          Vue.prototype.$_Toast.hide();
          generator.next();
        }, 3100);
      } else {
        this.showGetFailedDialog();
        Vue.prototype.$_Toast.hide();
      }
    } catch (error) {
      // 弹失败的框
      this.showGetFailedDialog();
      Vue.prototype.$_Toast.hide();
    }
  }
}
export default new FreeFollowUtil();
